// extracted by mini-css-extract-plugin
export default {"text-orange":"OrderMaterial_text-orange__ZTtr9","right-section-wrapper":"OrderMaterial_right-section-wrapper__9BUVE","dropdown":"OrderMaterial_dropdown__i5EfX"};